import React from 'react';
import { Button } from 'iglooform';
import { CheckOutlined } from 'iglooicon';
import { Row, Col } from 'antd';
import useMobile from '@/hooks/useMobile';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { isUndefined } from '@/utils/common';
import './index.less';

import { images } from '@/assets/images';

const ProductCard = (props: any) => {
  const {
    icon,
    price,
    productName,
    insurerName,
    commission,
    point,
    coverage,
    description = [],
    buttonOnClick,
    productKey,
    planKey,
    totalStep,
  } = props;

  const { formatMessage } = useIntl();
  const isMobile = useMobile();

  return (
    <div
      className={classnames([
        'cardBox',
        {
          'is-mobile': isMobile,
        },
      ])}
    >
      <Row className="top" gutter={8} wrap={false}>
        <Col>
          <div className={'productIconWrap'}>
            <img src={icon} className={'productIcon'} />
          </div>
        </Col>
        <Col>
          <div className={'productName'}>{productName}</div>
          <div className={'insurerName'}>{insurerName}</div>
        </Col>
      </Row>

      {coverage && <div className={'coverageDesc'}>{coverage}</div>}

      {!!description.length && (
        <Row className="description" gutter={[0, 8]}>
          {description.map((des: any, index: number) => {
            return (
              <React.Fragment key={index}>
                <Col key={index} span={24}>
                  <CheckOutlined />
                  <div
                    className={classnames({
                      strong: des.strong,
                    })}
                  >
                    <div>{des.text}</div>
                    {des?.subItems?.length > 0 && (
                      <ul className="desc-sub-items">
                        {des?.subItems?.map((e: any) => {
                          return (
                            <li key={e.id} className="desc-sub-item">
                              {e.text}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </Col>
              </React.Fragment>
            );
          })}
        </Row>
      )}

      {!isUndefined(commission) && (
        <Row className="middle" align="middle">
          <Col span={24} className="middle-col">
            <img src={images.commission_icon} className={'middleIcon'} />
            <span className={'text'}>
              {formatMessage({ id: 'Commission' })}
            </span>
            <span className={'ratio'}> {commission}</span>
          </Col>
        </Row>
      )}

      <Row
        className={classnames([
          'bottom',
          {
            'bottom-row-reverse': typeof price === 'undefined',
          },
        ])}
        justify="space-between"
        align={'middle'}
      >
        {price && <Col className={'price'}>{price}</Col>}
        <Col>
          <Button
            type="primary"
            className={'quoteButton'}
            onClick={(e) => {
              e.stopPropagation();
              buttonOnClick && buttonOnClick();

              // event tracking: quote this product
              window.gtag('event', 'quote_this_product', {
                page: 'product_landing',
                product_key: productKey,
                plan_key: planKey,
                user_unique_id: JSON.parse(
                  localStorage.getItem('user_info') ?? '{}',
                )?.id,
              });
            }}
          >
            {formatMessage({ id: 'Get Quote' })}
          </Button>
          {totalStep !== '3' && (
            <Button
              type="primary"
              className={'quoteButton'}
              style={{ marginLeft: '12px' }}
              onClick={(e) => {
                e.stopPropagation();
                buttonOnClick && buttonOnClick('buyNow');

                // event tracking: quote this product
                window.gtag('event', 'quote_this_product', {
                  page: 'product_landing',
                  product_key: productKey,
                  plan_key: planKey,
                  user_unique_id: JSON.parse(
                    localStorage.getItem('user_info') ?? '{}',
                  )?.id,
                });
              }}
            >
              {formatMessage({ id: 'Buy Now' })}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProductCard;
